import { useQuery } from '@tanstack/react-query';
import axiosClient from 'axiosClient';

export const useStations = () => {
  return useQuery({
    queryKey: ['stations-data'],
    queryFn: async () => {
      // 1. Parallel Fetch
      const [stationsRes, defaultsRes] = await Promise.all([
        axiosClient.get("/station-lists"),
        axiosClient.get("/station-lists/settings/defaults").catch(() => ({ data: {} }))
      ]);

      const rawStations = stationsRes.data.data || [];
      const defaultsData = defaultsRes.data?.data || {};
      
      // Safety: Handle potential casing differences
      const globalDefaultMain = defaultsData.main_image || defaultsData.mainImage || null;
      const globalDefaultThumb = defaultsData.thumbnail || null;

      // 2. Filter & Merge Logic
      return rawStations
        // --- ADD THIS FILTER TO HIDE CLOSED STATIONS ---
        .filter(station => !station.is_closed) 
        // -----------------------------------------------
        .map(station => {
          // A. Resolve Thumbnail
          const hasCustomThumbnail = station.thumbnail && station.thumbnail !== "";
          const finalThumbnail = hasCustomThumbnail ? station.thumbnail : globalDefaultThumb;

          // B. Resolve Main Image
          const hasCustomMain = station.mainImage && station.mainImage !== "";
          const finalMain = hasCustomMain ? station.mainImage : globalDefaultMain;

          return {
            ...station,
            thumbnail: finalThumbnail,
            mainImage: finalMain,
            // Fallback for the UI display if both are somehow missing
            displayImage: finalThumbnail || finalMain
          };
        });
    },
  });
};